import styled, { css } from 'styled-components';

const fontWeightL = 500;
const fontWeightXL = 'bold';
const borderWidth = '1px';
const borderColor = 'rgba(255,255,255,0.4)';
const rowLineHeight = '18px';
const rowCellPadding = '4px';
const rowHeight = rowLineHeight * 2 + rowCellPadding * 2;
const cellPriceWidth = '80px';

const firstRowStyles = css`
  margin-top: 32px;
  border-top: ${borderWidth} solid ${borderColor};
`;
const primaryRowStyles = css`
  font-weight: ${fontWeightXL};
  background-color: rgba(255, 255, 255, 0.1);
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  width: 100%;
  border-bottom: ${borderWidth} solid ${borderColor};
  line-height: ${rowLineHeight};
  height: ${rowHeight};
  font-weight: ${fontWeightL};

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  ${props => props.isFirstRow && firstRowStyles}
  ${props => props.isPrimary && primaryRowStyles}
`;
const Description = styled.div`
  display: flex;
  padding: ${rowCellPadding};
  flex: 1;
  margin-left: 12px;
`;
const Price = styled.div`
  display: flex;
  padding: ${rowCellPadding};
  min-width: ${cellPriceWidth};
  max-width: ${cellPriceWidth};
  justify-content: center;
`;

export default {
  Row,
  Description,
  Price,
};
